import request from '@/api/request'
//推荐职位
export function indexlist(data) {
    return request({
        url: '/api/job/index/list',
        method: 'GET',
        params: data
    })
}

//职位更多接口
export function jobmorelist(data) {
    return request({
        url: '/api/job/more/list',
        method: 'GET',
        params: data
    })
}

//职位搜索接口
export function searchlist(data) {
    return request({
        url: '/api/job/search/list',
        method: 'GET',
        params: data
    })
}




//职位详情推荐职位
export function recommendlist(data) {
    return request({
        url: '/api/job/recommend/list',
        method: 'GET',
        params: data
    })
}


//职位收藏接口
export function addCollect(data) {
    return request({
        url: '/api/collect/addCollect',
        method: 'POST',
        data
    })
}
//新报名接口
export function jobPostEnroll(data) {
    return request({
        url: '/api/job/postEnroll',
        method: 'POST',
        data
    })
}
//新职位详情接口
export function jobShow(data) {
    return request({
        url: '/api/job/jobShow',
        method: 'GET',
        params: data
    })
}

//职位地址接口
export function jobAddressList(data) {
    return request({
        url: '/api/jobAddress/addressList',
        method: 'GET',
        params: data
    })
}
